import { render, staticRenderFns } from "./AddCommunicationComponent.vue?vue&type=template&id=39602f23"
import script from "./AddCommunicationComponent.vue?vue&type=script&lang=js"
export * from "./AddCommunicationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports